import { ErrorMessage, Field, Form, Formik, FormikActions } from 'formik'
import { Typeahead } from 'react-bootstrap-typeahead'
import { ITSError } from '../Layout/ITSError'
import loadingBox from '../../assets/images/loading_box.gif'
import React from 'react'
import * as Yup from 'yup'
import { Article } from '../../types/DataTypes'

export interface AuthenticCheckFormValues {
  article: string
  batch: string
  serial: string
}

interface Props {
  handleSubmit: (values: AuthenticCheckFormValues, actions: FormikActions<AuthenticCheckFormValues>) => void
  articleNoSource: Article[]
}

export const AuthenticCheckForm: React.FunctionComponent<Props> = props => {
  const authenticCheckFormInitialValues: AuthenticCheckFormValues = {
    article: '',
    batch: '',
    serial: '',
  }

  const authenticCheckFormValidationSchema = () => {
    return Yup.object().shape({
      article: Yup.string()
        .required('Article Number is required')
        .test(
          'is-article-number-valid',
          'Article Number is not valid',
          (articleNo: string = '') =>
            props.articleNoSource.map((item: Article) => item.SKU.toUpperCase()).indexOf(articleNo.toUpperCase()) !==
            -1,
        )
        .test(
          'is-article-number-length-valid',
          'Article Number is not valid',
          (articleNo: string = '') => articleNo.length === 6 || articleNo.length === 10,
        ),
      batch: Yup.string()
        .required('Batch number is required'),
      serial: Yup.string()
        .required('Serial number is required'),
    })
  }

  return (
    <Formik
      initialValues={authenticCheckFormInitialValues}
      validationSchema={authenticCheckFormValidationSchema}
      enableReinitialize={true}
      onSubmit={props.handleSubmit}
      render={({ isValid, isSubmitting, handleChange, setFieldValue, setFieldTouched }) => {
        return (
          <Form className="authentic-check-form">
            <Typeahead
              id="article"
              multiple={false}
              onChange={(selected: string[]) => {
                if (selected[0]) {
                  setFieldValue('article', selected[0])
                }
              }}
              onInputChange={(text: string) => {
                setFieldValue('article', text)
              }}
              onBlur={() => {
                setFieldTouched('article', true)
              }}
              options={props.articleNoSource.map((item: Article) => item.SKU)}
              placeholder="Article Number"
              inputProps={{
                className: `form-control dw-input${!!props.articleNoSource.length && ' options-loaded'}`,
                name: 'article',
                autoComplete: 'off',
              }}
              minLength={2}
            />
            <ErrorMessage name="article" render={errorMessage => <ITSError errorMessage={errorMessage} />} />
            <Field name="batch" className="form-control dw-input" placeholder="Batch Number" />
            <ErrorMessage name="batch" render={errorMessage => <ITSError errorMessage={errorMessage} />} />
            <Field name="serial" className="form-control dw-input" placeholder="Serial Number" />
            <ErrorMessage name="serial" render={errorMessage => <ITSError errorMessage={errorMessage} />} />
            {!isSubmitting ? (
              <button type="submit" id="search-btn" className="btn btn-default dw-btn" disabled={!isValid}>
                Search
              </button>
            ) : (
              <img src={loadingBox} className="loading" alt="loading" />
            )}
          </Form>
        )
      }}
    />
  )
}
